module.exports = __webpack_public_path__ + "img/img_3.54908a45.png";